import i18n from "../../../i18n";import { Trans } from "react-i18next";import { useState } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from "../../../components/ui/dialog";
import { Textarea } from "../../../components/ui/textarea";
import { cn } from "../../../lib/utils";

/**
 * Collects HR's remarks before sending an announcement back to its author.
 * Confirm stays disabled until remarks are non-empty.
 */
export function SendBackModal({ open, onConfirm, onClose, loading }) {
  const [remarks, setRemarks] = useState("");

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogPortal>
        <DialogOverlay className="bg-[#0a1230]/50 backdrop-blur-sm" />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2",
            "w-[95vw] sm:w-[480px] max-w-[480px] bg-white rounded-2xl",
            "shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)] border border-white/60 font-sans",
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
          )}>
          
          <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--color-text-border)]/70">
            <DialogTitle className="text-[18px] font-bold text-foreground"><Trans i18nKey="formActions.sendBack" /></DialogTitle>
            <button
              type="button"
              onClick={onClose}
              className="h-8 w-8 rounded-lg grid place-items-center text-muted-foreground hover:bg-[var(--color-workspace)]"
              aria-label={i18n.t("formActions.close")}>
              
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="px-6 py-5">
            <label className="block text-xs font-semibold text-[var(--color-text-secondary)] mb-1.5">
              <Trans i18nKey="common.remarks" /> <span className="text-[var(--color-error)]">*</span>
            </label>
            <Textarea
              rows={4}
              className="rounded-xl"
              placeholder={i18n.t("announcements.explainWhatNeedsToBeCorrectedBeforeResubmitting")}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)} />
            
          </div>

          <div className="flex justify-end gap-3 px-6 py-4 border-t border-[var(--color-text-border)]/70">
            <button
              type="button"
              onClick={onClose}
              className="h-10 px-5 rounded-xl border border-[var(--color-text-border)] bg-white text-sm font-semibold text-foreground hover:bg-[var(--color-workspace)]">
              <Trans i18nKey="formActions.cancel" />
            
            </button>
            <button
              type="button"
              onClick={() => onConfirm(remarks)}
              disabled={!remarks.trim() || loading}
              className="h-10 px-5 rounded-xl bg-[var(--color-primary)] text-white text-sm font-semibold hover:bg-[var(--color-accent)] disabled:opacity-50 disabled:cursor-not-allowed">
              
              {loading ? "Sending…" : "Send Back"}
            </button>
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>);

}
